'use client'

import type { ReactNode } from 'react'
import { useHydration } from '@/lib/store'

const defaultFallback = (
  <div className="flex min-h-[40vh] items-center justify-center">
    <div
      className="h-8 w-8 animate-spin rounded-full border-2 border-muted-foreground border-t-transparent"
      aria-hidden
    />
  </div>
)

interface SafeHydrationProps {
  children: ReactNode
  fallback?: ReactNode
}

/**
 * 하이드레이션 완료 후에만 children 렌더 (페이지별 useHydration 중복 제거)
 */
export function SafeHydration({ children, fallback }: SafeHydrationProps) {
  const hydrated = useHydration()
  if (!hydrated) return <>{fallback ?? defaultFallback}</>
  return <>{children}</>
}
